exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#travelRuleForm .nolap{margin-top:15px;margin-bottom:20px}#travelRuleForm .address p{margin-top:21px;margin-bottom:21px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-form-components/src/travel-rule/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/travel-rule/styles.less
// module chunks = 1